// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JHIy","footer":"styles_footer__brqYV","passCodeTooltip":"styles_passCodeTooltip__Sx6ws"};